import t from 'react-translate'
import { css } from '@emotion/react';
import { gray4 } from 'styles/global_defaults/colors';
import { halfSpacing } from 'styles/global_defaults/scaffolding';

const styles = css`
  width: 200px;
  height: 200px;
  gap: ${halfSpacing}px;
  .score {
    font-size: 60px;
  }
  .score-measure {
    height: 25px;
    border-top: 1px solid ${gray4};
  }
`;

type NpsScoreProps = {
  score: number;
  componentType: 'nps' | 'csat';
};

const NpsCsatScore = ({ score, componentType }: NpsScoreProps) => {
  let colorClass = 'color-danger';
  if (score >= 30) {
    if(componentType === 'nps') {
      colorClass = 'color-yellow';
    }
    else
    {
      colorClass = 'color-warning';
    }
  }
  if (score >= 70) {
    colorClass = 'color-success';
  }

  return (
    <div css={styles} className='p-2 bg-white d-flex flex-column'>
      <span className='bold'>{componentType === 'nps' ? t.COURSE_ANALYTICS.NPS_CSAT_SURVEY.NPS() : t.COURSE_ANALYTICS.NPS_CSAT_SURVEY.CSAT()}</span>
      <div className='d-flex flex-column flex-grow-1'>
        <span className={`score text-center bold ${colorClass} mt-2`}>
          {score}{componentType === 'csat' ? '%' : ''}
        </span>
        {componentType === 'nps' && (
          <div className='score-measure d-flex align-items-center text-small text-regular font-weight-bold'>
            <div className='color-danger flex-grow-1'>-100</div>
            <div className='text-center color-gray-4 flex-grow-1'>0</div>
            <div className='color-success text-right flex-grow-1'>100</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NpsCsatScore;
